import React from 'react';

import PropTypes from 'prop-types';
import { SimpleSnapshotContainer as SnapshotContainer, SnapshotItem } from 'ctm-components';

const CommencementDate = ({ commencementDate, onClick, getHref }) => {
    const commencementUrl = 'commencement_date';

    return (
        <SnapshotContainer title="Commencement date">
            <SnapshotItem identifier="commencementDate" href={getHref(commencementUrl)} label={commencementDate} onClick={() => onClick(commencementUrl)} />
        </SnapshotContainer>
    );
};

CommencementDate.propTypes = {
    commencementDate: PropTypes.string,
    onClick: PropTypes.func,
    getHref: PropTypes.func
};

export { CommencementDate };
